import { render, staticRenderFns } from "./SkillItem.vue?vue&type=template&id=3486c734&scoped=true&"
import script from "./SkillItem.vue?vue&type=script&lang=js&"
export * from "./SkillItem.vue?vue&type=script&lang=js&"
import style0 from "./SkillItem.vue?vue&type=style&index=0&id=3486c734&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3486c734",
  null
  
)

export default component.exports